function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr))
    return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
import { Icon } from '@nordlayer/rivendell-ui';
import { PRODUCTS_LIST_PATH } from 'shared/constants/routes';
import { ACTIVITY_LIST_PATH } from 'routing/routes/activity/constants';
import { COUPONS_LIST_PATH } from 'routing/routes/coupons/constants';
import { PLANS_LIST_PATH } from 'routing/routes/customPlansManagement/constants';
import { DISTRIBUTORS_LIST_PATH } from 'routing/routes/distributors/constants';
import { MEMBERS_LIST_PATH } from 'routing/routes/members/constants';
import { ORGANIZATIONS_LIST_PATH } from 'routing/routes/organizations/constants';
import { PARTNERS_PATH } from 'routing/routes/partners/constants';
import { REFUNDS_LIST_PATH } from 'routing/routes/refunds/constants';
import { RESELLERS_LIST_PATH } from 'routing/routes/resellers/constants';
import { USERS_ROLES_LIST_PATH } from 'routing/routes/roles/constants';
import { SERVER_LIST_PATH } from 'routing/routes/servers/constants';
import { USERS_LIST_PATH, USERS_MANAGEMENT_PATH } from 'routing/routes/users/constants';
import { Features } from 'types/features/enums';
import { PermissionsEnum } from 'types/permissions/enums';
import { NAVIGATION_ITEM_TYPES } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
var redesignedUsersManagementItem = {
    label: 'Users management',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "administrators16"
    }),
    type: NAVIGATION_ITEM_TYPES.menu,
    permissions: [PermissionsEnum.ViewUsers],
    items: [{
            label: 'Users',
            href: USERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewUsers],
            size: 'md'
        }, {
            label: 'Roles',
            href: USERS_ROLES_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewUsers],
            size: 'md'
        }]
};
var distributorsItem = {
    label: 'Distributors',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "distributors16"
    }),
    href: DISTRIBUTORS_LIST_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    size: 'md'
};
var oldUsersManagementItem = {
    label: 'User management',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "administrators16"
    }),
    href: USERS_MANAGEMENT_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    permissions: [PermissionsEnum.ViewUsers],
    size: 'md'
};
export var getNavigationItems = function getNavigationItems(isUsersManagementEnabled, isDistributorsEnabled) {
    return [{
            label: 'Organizations',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "organizations16"
            }),
            href: ORGANIZATIONS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewOrganization],
            size: 'md'
        }, {
            label: 'MSP Partners',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "msp_partners16"
            }),
            href: PARTNERS_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewPartner],
            size: 'md'
        }, {
            label: 'Resellers',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "resellers16"
            }),
            href: RESELLERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ResellersManagement],
            size: 'md'
        }].concat(_toConsumableArray(isDistributorsEnabled ? [distributorsItem] : []), [{
            label: 'Members',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "member16"
            }),
            href: MEMBERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewMember],
            size: 'md'
        }, {
            label: 'Servers',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "servers16"
            }),
            href: SERVER_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewServer],
            size: 'md'
        }, {
            label: 'Refunds',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "refunds16"
            }),
            href: REFUNDS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewRefund],
            size: 'md'
        }, {
            label: 'Activity',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "activity16"
            }),
            href: ACTIVITY_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewActivityLog],
            size: 'md'
        }, {
            label: 'Custom plans',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "custom_plans16"
            }),
            href: PLANS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewDirectPlansAndPackages, PermissionsEnum.ViewPartnerPlansAndPackages],
            size: 'md'
        }, {
            label: 'Coupons',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "coupons16"
            }),
            href: COUPONS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewCoupon],
            size: 'md'
        }], _toConsumableArray(isUsersManagementEnabled ? [redesignedUsersManagementItem] : [oldUsersManagementItem]), [{
            label: 'Products',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "subscription16"
            }),
            href: PRODUCTS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            allowedFeatureFlags: [Features.MultiProductProductsPage],
            permissions: [PermissionsEnum.ProductsManage],
            size: 'md'
        }]);
};
